import { createFileRoute } from '@tanstack/react-router';

import { AuditWorkspacePage } from '@/features/audit-workflow/components/AuditWorkspacePage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/audit/audits/$auditId/')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.auditWorkspace'),
  }),
  component: AuditWorkspaceRoute,
});

function AuditWorkspaceRoute() {
  const { auditId } = Route.useParams();
  return <AuditWorkspacePage auditId={auditId} />;
}
